module.exports = __webpack_public_path__ + "img/house.b9cabb66.svg";